import { outlineOf } from './outline';
export const MARKDOWN_MIME_TYPE = 'text/markdown';
/** Characters that start Markdown syntax anywhere in a line. */
const INLINE_SYNTAX = /([\\`*_[\]<>|])/g;
/** Escapes what would otherwise be read as formatting, and keeps a node on one line. */
export function escapeMarkdown(text) {
    const inline = text.replace(/\s*\n\s*/g, ' ').replace(INLINE_SYNTAX, '\\$1');
    // At the start of a line these open a heading, a list or a quote.
    return inline.replace(/^(#|>|-|\+|\d+\.)/, '\\$1');
}
export function renderMarkdown(document) {
    const lines = [];
    for (const item of outlineOf(document)) {
        if (item.depth === 0) {
            lines.push(`# ${escapeMarkdown(item.text)}`, '');
            if (item.notes !== '')
                lines.push(...item.notes.split('\n').map(escapeMarkdown), '');
            continue;
        }
        const indent = '  '.repeat(item.depth - 1);
        lines.push(`${indent}- ${escapeMarkdown(item.text)}`);
        if (item.notes !== '') {
            // Indented to the bullet's text, so a renderer keeps the note inside the list item.
            for (const line of item.notes.split('\n')) {
                lines.push(`${indent}  ${escapeMarkdown(line)}`);
            }
        }
    }
    return `${lines.join('\n').trimEnd()}\n`;
}
//# sourceMappingURL=markdown.js.map